import { createFileRoute } from "@tanstack/react-router";
import { ShieldAlert } from "lucide-react";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { SurvivalProtocolCard } from "@/components/SurvivalProtocolCard";
import { usePageView } from "@/hooks/use-page-view";
import { SURVIVAL_PROTOCOLS } from "@/data/survival-protocols";

const TITLE = "19 Survival Protocols That Reverse Bad Instinct - Smartasaurus";
const DESC =
  "19 free, sourced survival cards: sinking cars, rip currents, fires, floods, lightning, choking, CPR, stroke, heat, earthquakes, tornadoes, snakebite and more. No email.";

export const Route = createFileRoute("/survival")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://smartasaurus.com/survival" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
    ],
    links: [{ rel: "canonical", href: "https://smartasaurus.com/survival" }],
  }),
  component: SurvivalPage,
});

function SurvivalPage() {
  usePageView("survival_protocols");

  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main id="main-content">
        <section className="border-b border-border px-4 py-12 md:px-8 md:py-16">
          <div className="mx-auto max-w-5xl">
            <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.28em] text-primary">
              <ShieldAlert className="h-4 w-4" /> Free · sourced · no email
            </div>
            <h1 className="mt-4 max-w-4xl font-display text-4xl uppercase leading-none md:text-7xl">
              {SURVIVAL_PROTOCOLS.length} survival cards worth keeping
            </h1>
            <p className="mt-5 max-w-3xl text-lg leading-relaxed text-muted-foreground">
              Movies taught the myth. Physics and biology decide what happens next. Save any card straight to your phone, then share it with someone who might need it.
            </p>
            <p className="mt-4 max-w-3xl text-xs leading-relaxed text-muted-foreground">
              Emergency guidance varies by place and situation. Call local emergency services when safe. This page supports preparation; it does not replace certified first-aid or rescue training.
            </p>
          </div>
        </section>

        <section id="protocols" className="px-4 py-10 md:px-8 md:py-16">
          <div className="mx-auto grid max-w-5xl gap-12 sm:grid-cols-2 md:gap-14">
            {SURVIVAL_PROTOCOLS.map((protocol, index) => (
              <SurvivalProtocolCard key={protocol.id} protocol={protocol} number={index + 1} />
            ))}
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}